<template>
	<modal class="ui ui--fontSize" role="dialog">
		<ElementButton name="close" @click="close" />
		<ElementHeadlineBig content="fontSizeModalMsg" i18n />
		<ElementList ref="menu" :entries="fontSizeButtons" role="menu" />
		<ElementButton name="close" @click="close" content="close" i18n tabindex="0" />
	</modal>
</template>

<script>
import { mapState } from 'vuex';
import UiBase from './base.vue';
import { uiComponents } from '../../tools/viewState';
import { i18n } from '../../tools/i18n';

export default {
	extends: UiBase,
	data() {
		return {
			name: uiComponents.uiFontSize,
		};
	},
	computed: {
		...mapState(['viewState']),
		fontSizeButtons() {
			const settings = ['smaller', 'medium', 'larger', 'largest'];
			return settings.map(setting => ({
				name: setting,
				title: i18n.t(setting),
				url: `command://setFontSize?size=${setting}|closeModal?id=ui--fontSize`,
			}));
		},
	},
	mounted() {
		this.$refs.menu.$el.childNodes[0].focus();
	},
};
</script>
